//https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#style-y076
searchResults.$inject = ['$log'];

function searchResults() {
    const directive = {
        restrict: 'E',
        replace: true,
        template: `
            <div class="c-suggest-search" data-ng-class="{'c-suggest-search--show' : vm.hasResults()}">
                <ul class="c-suggest-search__list list-unstyled">
                    <li class="c-suggest-search__headline" data-ng-show="vm.resultsProducts.length > 0">{{vm.productsText}}</li>
                    <li class="c-suggest-search__item" data-ng-repeat="result in vm.resultsProducts">
                        <a class="c-suggest-search__link text-truncate" href="{{vm.baseUrl}}{{result.url}}" title="{{result.brand.name}} {{result.name}}"><img loading="lazy" data-ng-src="{{result.plpThumbnailImage.normalQuality.url}}" width="{{vm.searchResultsPictureWidth}}"/>{{result.brand.name}} {{result.name}}</a> 
                    </li>
                    <li class="c-suggest-search__headline" data-ng-show="vm.resultsSuggestions.length > 0">{{vm.suggestionsText}}</li>
                    <li class="c-suggest-search__item" data-ng-repeat="result in vm.resultsSuggestions">
                        <a class="c-suggest-search__link text-truncate" href="{{vm.baseUrl}}/search?q={{result.term}}" title="{{result.term}}">{{result.term}}</a>
                    </li>
                </ul>
            </div>
        `,
        controller: searchResultsController,
        controllerAs: 'vm',
    };
    return directive;
}

searchResultsController.$inject = ['$log', '$rootScope', 'SearchService', 'CommonService'];

function searchResultsController($log, $rootScope, SearchService, CommonService) {
    let vm = this;
    vm.$onInit = onInit;
    vm.hasResults = hasResults;
    vm.resultsProducts = SearchService.resultsProducts;
    vm.resultsSuggestions = SearchService.resultsSuggestions;
    vm.baseUrl = CommonService.getBaseUrl();

    vm.productsText = SearchService.productsText;
    vm.suggestionsText = SearchService.suggestionsText;
    vm.searchResultsPictureWidth = SearchService.searchResultsPictureWidth;

    $rootScope.$on('newSuggestSearchData', () => {
        vm.resultsProducts = SearchService.resultsProducts;
        vm.resultsSuggestions = SearchService.resultsSuggestions;
    });

    function onInit() {
        $log.debug('searchResultsController initialized');
    }

    function hasResults() {
        // TODO: maybe check also the state of the focus (type and leave the inputfield)
        return SearchService.hasResults();
    }

    function getBaseUrl() {
        return SearchService.getBaseUrl();
    }
}

export default searchResults;
